/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Tanner Schermerhorn",
  title: "Hey there, I'm Tanner",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1wsxQ3GCWT_3z6HB0RsNWZ7QwSiwGqJgE/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/SoundPhoenix",
  //linkedin: "https://www.linkedin.com/in//",
  gmail: "me@tannerschermerhorn.dev",
  gitlab: "https://gitlab.com/SoundPhoenix",
  facebook: "https://www.facebook.com/tanner.schermerhorn.2025",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Program both front-end and back-end applications with JavaScript, Python, and Shell Scripting"
    ),
    emoji("⚡ Develop discord applications with discord.js and typescript"),
    emoji(
      "⚡ Create different shell scripts to automate and manage tasks with bash and python"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "shell scripting",
      fontAwesomeClassname: "fas fa-terminal"
    },
    {
      skillName: "markdown",
      fontAwesomeClassname: "fab fa-markdown"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true 
  //Set to true once getting into college or a higher education
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "20%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Technical Support",
      company: "SkylinkHosting LLC",
      companylogo: require("./assets/images/Logo.png"),
      date: "September 13th 2025 – December 15th 2025",
      desc: "Provided technical support and troubleshooting for SkylinkHosting LLC's clients, ensuring timely resolution of issues and maintaining high customer satisfaction.",
      descBullets: [
        "Assisted customers with technical problems related to hosting services",
        "Collaborated with the development team to identify and resolve software bugs"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};


// Donate Section
const donateSection ={
  title: "Want to donate?",
  subtitle: "HERE ARE SOME WAYS YOU CAN SUPPORT ME",
  
  donate: [
    {
      image: require ("./assets/images/buymeacoffee.png"),
      name: "Buy Me a Coffee",
      website: "https://www.buymeacoffee.com/tannerschermerhorn",
      description: "You can support me by buying me a coffee. Every coffee helps me stay up late and work on projects."

    }

  ]
}



// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME PROJECTS THAT I HAVE WORKED ON THAT ARE STILL IN PROGRESS",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "ZenithOS",
      projectDesc: "ZenithOS is a custom firmware for the flipper zero. It offers more features and customization than the stock firmware.",
      footerLink: [
        {
          name: "Github",
          url: "http://github.com/SoundPhoenix/ZenithOS-firmware"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Project Phoenix",
      projectDesc: "Project Phoenix is a discord bot that is designed to help manage and moderate discord servers.",
      footerLink: [
        {
          name: "Github",
          url: "http://github.com/SoundPhoenix/Project-Phoenix-v2"
        },
        
        {
          name: "Website",
          url: "https://phoenix.tannerschermerhorn.dev"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Microsoft Word Associate Microsoft Certified: 365 Apps",
      subtitle:
        "Completed the Microsoft 365 Apps certification exam. This exam covers the basics of Microsoft 365 Apps.",
      image: require("./assets/images/Microsoft_365_Logo.png"),
      imageAlt: "Microsoft 365 Apps Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/17-wOCvnlv5Eqoe9RnQJfubKreSbiRziE/view?usp=sharing"
        },
      ]
    },
    {
      title: "Test Out IT Fundamentals",
      subtitle:
        "Completed the Test Out IT Fundamentals certification exam. This exam covers the basics of computer hardware, software, and networking.",
      image: require("./assets/images/testout.jpg"),
      imageAlt: "Test Out Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1II_2gqIF5GPg22JkwGCTnJG4Ycmn-P6b/view?usp=sharing"
        }
      ]
    },

    {
      title: "Test Out Office Pro",
      subtitle: "Completed the Test Out Office Pro certification exam. This exam covers the basics of Microsoft Office.",
      image: require("./assets/images/testout.jpg"),
      imageAlt: "Test Out Logo",
      footerLink: [
        {
          name: "Certification", 
          url: "https://drive.google.com/file/d/1Vhv58iuBxeiZzCaIZAy8aIRKwb-YWmKN/view?usp=sharing"
        },
      ]
    },

    {
      title: "Microsoft Word Expert Microsoft 365 Apps",
      subtitle:
        "Completed the Microsoft Word Expert Exam. This exam covers the advanced tools of Microsoft Word.",
      image: require("./assets/images/Microsoft_365_Logo.png"),
      imageAlt: "Microsoft 365 Apps Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1yAwguSztE6jndQZOLbEzaH7bciCExJHj/view?usp=drive_link"
        },
      ]
    },
    {
      title: "Microsoft Excel Associate Microsoft 365 Apps",
      subtitle:
        "Completed the Microsoft Excel Associate Exam. This exam covers the basics of Microsoft Excel.",
        image: require("./assets/images/Microsoft_365_Logo.png"),
        imageAlt: "Microsoft 365 Apps Logo",
        footerLink: [
          {
            name: "Certification",
            url: "https://drive.google.com/file/d/1gJv5-lohIs4J73t24ZpAsa6zd9lF-HCH/view?usp=drive_link"
          },
        ]
      },
      {
        title: "Microsoft Powerpoint Associate Microsoft 365 Apps",
        subtitle:
          "Completed the Microsoft Powerpoint Exam This exam covers the basics of Microsoft Powerpoint.",
          image: require("./assets/images/Microsoft_365_Logo.png"),
          imageAlt: "Microsoft 365 Apps Logo",
          footerLink: [
            {
              name: "Certification",
              url: "https://drive.google.com/file/d/1dmZBXGECIytuxQki76t5U37tuRlI3u1V/view",
            },
          ]
        },
      {
          title: "Microsoft Office Specialist Associate Microsoft 365 Apps",
          subtitle:
            "Completed the Microsoft Office Exams this covers everything in the Microsoft 365 office suite.",
            image: require("./assets/images/Microsoft_365_Logo.png"),
            imageAlt: "Microsoft 365 Apps Logo",
            footerLink: [
            {
                name: "Certification",
                url: "https://drive.google.com/file/d/1ZcMLeCxLQZFKkQX88TXDNG_XVQqmoy00/view",
            },
          ]
        },
              {
          title: "CompTIA PC Pro",
          subtitle:
            "Completed the CompTIA PC Pro exam, this covers everything having to do with PC hardware and software.",
            image: require("./assets/images/comptiaPCpro.jpeg"),
            imageAlt: "CompTIA PC Pro Logo",
            footerLink: [
            {
                name: "Certification",
                url: "https://drive.google.com/file/d/1ZcMLeCxLQZFKkQX88TXDNG_XVQqmoy00/view",
            },
          ]
        },
        {
          title: "CompTIA A+",
          subtitle:
            "Completed the CompTIA A+ exams covering Core 1 and Core 2, these cores cover security, mobile devices, operating systems, hardware and software.",
            image: require("./assets/images/comptiaA+.jpeg"),
            imageAlt: "CompTIA A+ Logo",
            footerLink: [
            {
                name: "Certification",
                url: "https://drive.google.com/file/d/10o-JMyi0hrYj373x0Fq2cR6Gz2v9__92/view?usp=drive_link",
            },
          ]
        }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  //number: "+92-0000000000",
  email_address: "me@tannerschermerhorn.dev"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  donateSection
};
